(function() {
    const NB_CHARS_SPLIT_TITLE = 12;
    const NB_CHARS_SPLIT_DESC = 18;
    const ROW_HEIGHT_TITLE = 40;
    const ROW_HEIGHT_DESC = 21;
    const SVGNS = "http://www.w3.org/2000/svg";
    // Jauge budget : échelle de € (n actifs colorés, le reste atténué)
    const BUDGET_MAX = 4;
    const BUDGET_ON = "#62B34F";
    const BUDGET_OFF = "#d0d0d0";
    const decorateSummary = (object, args)=>{
        const splitIntoLines = (input, maxLen)=>{
            const words = input.split(" ");
            return words.reduce((acc, word)=>{
                let currentLine = acc.pop() || "";
                if (currentLine.length + word.length <= maxLen || currentLine === "") currentLine += currentLine ? " " + word : word;
                else {
                    acc.push(currentLine);
                    currentLine = word;
                }
                acc.push(currentLine);
                return acc;
            }, []);
        };
        if (!object) return;
        let svg = object.getSVGDocument();
        if (args.svgTitle) {
            const titleEl = svg.querySelector("#global-title");
            if (titleEl) titleEl.innerHTML = args.svgTitle;
        }
        [
            "date",
            "client",
            "tech",
            "budget"
        ].forEach((area)=>{
            const svgField = svg.querySelector(".area-" + area) || svg.querySelector("#" + area);
            if (!svgField) return;
            if (!args[area]) {
                svgField.style.display = "none";
                return;
            }
            svgField.innerHTML = "";
            let xPos = parseFloat(svgField.dataset.x);
            let yPos = parseFloat(svgField.dataset.y);
            // Titre : jauge de € pour le budget (via level), sinon texte multi-lignes
            if (area === "budget" && typeof args.budget.level === "number") {
                const meter = document.createElementNS(SVGNS, "text");
                meter.setAttribute("id", "budget-title-r1");
                meter.setAttribute("transform", "matrix(1 0 0 1 " + xPos + " " + yPos + ")");
                meter.setAttribute("class", "title budget-meter");
                for(let i = 0; i < BUDGET_MAX; i++){
                    const glyph = document.createElementNS(SVGNS, "tspan");
                    glyph.textContent = "€";
                    glyph.setAttribute("fill", i < args.budget.level ? BUDGET_ON : BUDGET_OFF);
                    meter.appendChild(glyph);
                }
                svgField.appendChild(meter);
                yPos += ROW_HEIGHT_TITLE;
            } else {
                const splittedTitle = splitIntoLines(args[area].title, NB_CHARS_SPLIT_TITLE);
                splittedTitle.forEach((line, idx)=>{
                    // <text id="date-title" transform="matrix(1 0 0 1 3.474 90.5532)" className="title">2022</text>
                    const textTitle = document.createElementNS(SVGNS, "text");
                    textTitle.setAttribute("id", area + "-title-r" + parseInt(idx + 1));
                    textTitle.setAttribute("transform", "matrix(1 0 0 1 " + xPos + " " + yPos + ")");
                    textTitle.setAttribute("class", "title");
                    textTitle.innerHTML = line;
                    yPos += ROW_HEIGHT_TITLE;
                    svgField.appendChild(textTitle);
                });
            }
            const splittedDesc = splitIntoLines(args[area].desc, NB_CHARS_SPLIT_DESC);
            splittedDesc.forEach((line, idx)=>{
                textDesc = document.createElementNS("http://www.w3.org/2000/svg", "text");
                textDesc.setAttribute("id", area + "-desc-r" + parseInt(idx + 1));
                textDesc.setAttribute("transform", "matrix(1 0 0 1 " + xPos + " " + yPos + ")");
                textDesc.setAttribute("class", "desc");
                textDesc.innerHTML = line;
                yPos += ROW_HEIGHT_DESC;
                svgField.appendChild(textDesc);
            });
        });
    };
    const initObject = (object)=>{
        try {
            if (typeof projectDetails !== "undefined" && projectDetails) decorateSummary(object, projectDetails);
            const svgDoc = object.getSVGDocument();
            if (svgDoc) {
                const svgRoot = svgDoc.querySelector("svg");
                if (svgRoot) {
                    // JS runs successfully, mark document to hide elements by default
                    svgRoot.classList.add("js-enabled");
                    const observer = new IntersectionObserver((entries)=>{
                        entries.forEach((entry)=>{
                            if (entry.isIntersecting) {
                                svgRoot.classList.add("visible");
                                observer.unobserve(object);
                            }
                        });
                    }, {
                        threshold: 0.05 // Trigger early when 5% of the SVG enters the screen
                    });
                    observer.observe(object);
                }
            }
        } catch (e) {
            console.error("Error initializing SVG summary:", e);
        }
    };
    const svgObject = document.querySelector("object");
    if (svgObject) {
        let svgDoc = null;
        try {
            svgDoc = svgObject.getSVGDocument();
        } catch (e) {}
        // If the SVG is already loaded (e.g. from cache before script execution)
        if (svgDoc && svgDoc.querySelector("svg")) initObject(svgObject);
        else svgObject.addEventListener("load", function(ev) {
            initObject(ev.target);
        });
    }
})();

//# sourceMappingURL=index.44489101.js.map
